/**
 * Allows only http(s) markdown destinations. Relative URLs resolve against a
 * harmless placeholder origin and are accepted as http URLs; every other
 * scheme and malformed value is rendered as inert text by the caller.
 */
export function safeMarkdownUrl(url: string): string {
    try {
        const parsed = new URL(url, 'http://localhost');
        if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
            return url;
        }
    } catch {
        // Invalid URLs render as inert text.
    }
    return '';
}
